module.exports = __webpack_public_path__ + "media/video-placeholder.asset.1401d0f0.mp4";